// Ruoli usati dalla visibilità delle voci di menu. Copiati alla lettera da App.tsx (card B del
// design M3): la visibilità NON cambia, cambia solo dove vive il codice. Il controllo reale resta
// sul server.

// F-061: ruoli che passano PolicyNames.Manager sul server (voce di menu "Process mining").
export const MANAGER_ROLES = ['Administrator', 'EqualAdmin', 'EqualDirettoreGenerale', 'EqualDirettoreCommerciale', 'EqualAreaManager']
// F-069: ruoli che passano PolicyNames.FinanceAdministrationRead sul server (Controllo Costi, Commercialista).
export const FINANCE_ADMIN_ROLES = ['Administrator', 'EqualAdmin', 'EqualAmministrazione', 'EqualCommercialista']
// Ruoli "Admin" (auth.role === 'Administrator' || auth.role === 'EqualAdmin' in App.tsx).
export const ADMIN_ROLES = ['Administrator', 'EqualAdmin']
// F-068 (TASK-0322): importazioni CSV; l'accesso reale lo decide il server (BackOffice).
export const IMPORT_ROLES = ['Administrator', 'EqualAdmin', 'EqualOperatore', 'EqualBackOffice']
// ADR-019 (Equal Point): ruoli che passano PolicyNames.EqualStaff sul server (progetti Studio).
export const STAFF_ROLES = ['Administrator', 'EqualAdmin', 'EqualDirettoreGenerale', 'EqualDirettoreCommerciale', 'EqualAreaManager', 'EqualOperatore', 'EqualBackOffice']
